import {
  and,
  asc,
  catalog_part,
  catalog_product,
  catalog_series,
  eq,
  or,
  type PowerSyncDrizzleDB,
} from "@famidex/powersync";

/**
 * CATÁLOGO GLOBAL — lecturas del cliente (dataset cacheado por el stream público
 * `catalog_public`, sin dueño). No hay papelera aquí: el catálogo es read-mostly
 * y global. El invitado sin token de sync usa los endpoints REST (/api/catalog).
 */

/** Lista de productos, opcionalmente filtrada por categoría. */
export function getCatalogProductsQuery(db: PowerSyncDrizzleDB, opts?: { category?: string }) {
  const base = db.select().from(catalog_product);
  const filtered = opts?.category ? base.where(eq(catalog_product.category, opts.category)) : base;
  return filtered.orderBy(asc(catalog_product.edition_name));
}

/** Detalle de un producto por id. */
export function getCatalogProductQuery(db: PowerSyncDrizzleDB, id: string) {
  return db.select().from(catalog_product).where(eq(catalog_product.id, id)).limit(1);
}

/**
 * Resuelve un producto por código de barras (EAN o UPC). Corazón del escáner:
 * barcode → producto → detalle → añadir. Devuelve la primera coincidencia.
 */
export function resolveBarcodeQuery(db: PowerSyncDrizzleDB, code: string) {
  return db
    .select()
    .from(catalog_product)
    .where(or(eq(catalog_product.ean, code), eq(catalog_product.upc, code)))
    .limit(1);
}

/** Piezas de un producto, ordenadas. */
export function getProductPartsQuery(db: PowerSyncDrizzleDB, productId: string) {
  return db
    .select()
    .from(catalog_part)
    .where(eq(catalog_part.product_id, productId))
    .orderBy(asc(catalog_part.sort_order));
}

/** Catálogo de series (para el progreso por serie y el explorador). */
export function getCatalogSeriesQuery(db: PowerSyncDrizzleDB) {
  return db.select().from(catalog_series).orderBy(asc(catalog_series.name));
}

/** Serie por id (para la cabecera del progreso). */
export function getCatalogSeriesByIdQuery(db: PowerSyncDrizzleDB, id: string) {
  return db.select().from(catalog_series).where(eq(catalog_series.id, id)).limit(1);
}

// Reexport de conveniencia: filtro combinado (categoría + serie) para Wave 1-A.
export function getCatalogProductsBySeriesQuery(db: PowerSyncDrizzleDB, seriesId: string) {
  return db
    .select()
    .from(catalog_product)
    .where(and(eq(catalog_product.series_id, seriesId)))
    .orderBy(asc(catalog_product.edition_name));
}
